import React, { useEffect, useState } from 'react'
import './DatumList.css'
import { FiBox } from 'react-icons/fi'
import { TbCompass } from 'react-icons/tb'
import { BiHash, BiPen } from 'react-icons/bi'
import { GiStamper } from 'react-icons/gi'
import { MdOutlineAssignmentTurnedIn } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { BsEye } from 'react-icons/bs'
import { loadModal } from '../../../../actions/ModalAction'
import { HiArrowsRightLeft } from 'react-icons/hi2'
import { generateRelationIcon } from '../../../../tools/generateRelationIcon'
import Relation from '../../CreateDatum/AddRelationModal/Relation/Relation'
import DraftModal from './DraftModal'
import { generateDatumTypeIcon } from '../../../../tools/datumTypeConversion'
import useEffectiveUser from '../../../../hooks/useEffectiveUser';

// Unused Imports
import { AiOutlineBarChart } from 'react-icons/ai'

const DatumList = ({ data, id, datum_state, triggerType, transferrence, setMainContent, user: propUser }) => {

    const { user: reduxUser } = useSelector((state) => state.authReducer.authData)
    const { rModalOpened } = useSelector((state) => state.modalReducer);
    const contextUser = useEffectiveUser()
    
    const cU = useSelector((state) => state.authReducer.authData)
    const user = rModalOpened
        ? (propUser || contextUser || reduxUser)
        : reduxUser
    const isOpen = useSelector((state) => state.datumeditReducer.isOpen)
    const [stamped, setStamped] = useState(data?.stamps?.includes(cU.user._id))
    const [stamps, setStamps] = useState(data?.stamps?.length)
    const [viewed, setViewed] = useState(data?.views?.includes(cU.user._id))
    const [views, setViews] = useState(data?.views?.length)
    const datumType = data?.datumType;

    const theme_arr = useSelector((state) => state.themeReducer.theme);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    useEffect(() => {
        setStamped(data?.stamps?.includes(cU.user._id));
        setStamps(data?.stamps?.length);
    }, [data?.stamps]);

    useEffect(() => {
        setStamped(data?.views?.includes(cU.user._id));
        setStamps(data?.views?.length);
    }, [data?.views]);

    useEffect(() => {
        setTriggers(getTriggers());
    }, [cU.user.stamps]);

    useEffect(() => {
        if (isOpen == true) {

        }
        else {
            setIsModalOpen(false)
        }
    }, [isOpen])

    const userImgPath = process.env.REACT_APP_PUBLIC_FOLDER + data.authorImage;

    const datumContainerClass = () => {
        var classText = 'Datum';
        if (datum_state == 'draft') { classText = 'Datum-Draft' }
        // if (data.itemTriggered) { classText += ' triggeredDatum' }
        if (user.userType === 2) { 
            if (triggerType === 'align') { classText += ' alignDatum' }
            if (triggerType === "conflict") { classText += ' triggeredDatum' }
        }
        if (user.userType === 0 && transferrence >= 0) {
            if (data.triggerTypes.length === 1) {
                if (data.triggerTypes[0] === "align") { classText += ' alignDatum' }
                else if (data.triggerTypes[0] === "conflict") { classText += ' triggeredDatum' }
                
            } else {
                const triggerValues = data.triggerTypes.map(stamp => stamp);
            
                if (triggerValues.every(value => value === null)) {
                    classText = '';
                } else if (triggerValues.some(value => value === "align") && triggerValues.every(value => value === "align" || value === null)) {
                    classText += ' alignDatum';
                } else if (triggerValues.some(value => value === "conflict") && triggerValues.every(value => value === "conflict" || value === null)) {
                    classText += ' triggeredDatum';
                } else {
                    classText += ' neutralDatum';
                }
            }
            
        }
        if (viewed) { classText += ' viewedDatum' }
        if (stamped) { classText += ' stampedDatum' }
        if (user.userType === 0) { classText += ' viewedDatum' }

        return classText;
    }

    const createdDate = () => {
        const date = new Date(data.createdAt);
        return (date.toDateString());
    }

    const followedGroupsBar = () => {
        return (
            <div className="bottom-bar FlexRow">
                <div className="dl-followed-groups">
                    {data?.stampDetails && data?.stampDetails.map((stamp, id) => {
                        return <img key={id} src={process.env.REACT_APP_PUBLIC_FOLDER + stamp.groupImage} />
                    })}
                </div>
            </div>
        )
    }
    const authorThemeBar = () => {
        return (
            <div className="bottom-bar FlexRow">
                <div className="datumDetails">
                    <div className="generalBar authorBar">
                        {datum_state == 'draft' ?
                            ''
                            :
                            <>
                                <BiPen />
                                <img src={userImgPath} alt="" className='authorBarImg' />
                            </>
                        }
                        <span className="datumAuthor">
                            @{data.authorName}
                        </span>
                        <span className="timestamp">{createdDate()}</span>
                    </div>

                    {(data?.themes?.length > 0) && <div className="generalBar themesBar">
                        <BiHash />
                        <span className="themes">
                            {data?.themes?.map((theme, _id) => {
                                if (theme_arr && theme_arr[theme]) {
                                    return (
                                        <span className='theme'>
                                            <a href='#'>
                                                {theme_arr[theme]}&nbsp;&nbsp;
                                            </a>
                                        </span>
                                    )
                                } else if (data?.themes?.[_id]?.theme) {
                                    return (
                                        <span className='theme'>
                                            <a href='#'>
                                                {data?.themes[_id]?.theme}&nbsp;&nbsp;
                                            </a>
                                        </span>
                                    )
                                }
                            })}
                        </span>
                    </div>}
                </div>
            </div>
        )
    }

    const getTriggers = () => {
        switch (user.userType) {
            case 0:
                let trigger = [];
                for (let g = 0; g < data?.stampDetails?.length; g++) {
                    if (data?.stampDetails[g].triggers) {
                        trigger.push(...data?.stampDetails[g].triggers)
                    }
                }
                return trigger;

            case 2:
                const stampIndex = user.stamps.findIndex((stamp) => stamp.datumId === data._id);
                if (stampIndex > -1) {
                    const trig = user.stamps[stampIndex].triggers
                    return trig
                } else {
                    return [];
                }
        }

    }
    const [triggers, setTriggers] = useState(getTriggers());

    const countTriggerTypes = (data) => {
        if (!Array.isArray(data)) {
            return { align: 0, conflict: 0 };
        }
        let align = 0;
        let conflict = 0;
      
        for (const obj of data) {
          if (obj.triggerType === 'align') {
            align++;
          } else if (obj.triggerType === 'conflict') {
            conflict++;
          }
        }
      
        return { align, conflict };
      };
    
    const { align, conflict } = countTriggerTypes(triggers);
    const dispatch = useDispatch();
    const loadDatum = () => {

        if (datum_state == 'draft') {
            toggleModal()
            // console.log('-----------------', datum_state)
        } else
        // if (user.userType == 2) 
        {
            const modalPackage = {
                modalType: "datum",
                data: data,
                stamped: stamped,
                setStamped: setStamped,
                stamps: stamps,
                setStamps: setStamps,
                viewed: viewed,
                setViewed: setViewed,
                views: views,
                setViews: setViews,
                triggers: triggers,
                setTriggers: setTriggers,
                datumtype: datum_state,
                setMainContent: setMainContent,
                triggerType: triggerType
            }

            const logDetails = {
                activity: "datum_view_opened",
                category: "interaction",
                userId: user._id,
                datumId: data._id,
                data: {
                    userId: user._id,
                    username: user.username,
                    datumId: data._id,
                    datumText: data.datumText
                },
                response: null,
                sessionId: localStorage.getItem('sessionId'),
                status: null
            }

            dispatch(loadModal(modalPackage, logDetails));
        }
    }

    return (
        <>
            <div
                id={"datum_container_" + id}
                className={datumContainerClass()}
                onClick={loadDatum}
            >
                <div className="datumBody">
                    <div className="generalBar">
                        {/* <AiOutlineBarChart size="1rem"/> */}
                        {data.datumText !== '' && data.datumText !== null && <span className='datumText'>
                            {generateDatumTypeIcon(datumType, data?.linkSubtype)} {data.datumText}
                        </span>}
                    
                        {(data.datumText === '' || data.datumText === null) && <span className='dl-relations FlexColumn'>
                            {data.relations.map((r) => {
                                return (
                                    <div className="FlexRow dl-relationRow">
                                        <span className="dl-endIcon FlexRow">
                                            {generateRelationIcon(r.text)}
                                        </span>
                                        <div className='dl-vl'></div>
                                        <span className="dl-relation">
                                            <Relation
                                                relation={r}
                                                references={data.references}
                                            />
                                        </span>
                                    </div>
                                )
                            })}

                        </span>}
                    </div>
                    <div className="generalBar attributes" >
                        <FiBox />
                        <span className="referenced">{data?.references?.length}</span>
                        <HiArrowsRightLeft />
                        <span className="relations">{data?.relations?.length}</span>
                        <MdOutlineAssignmentTurnedIn />
                        <span className="sources">{data?.sources?.length}</span>
                        <GiStamper style={user.userType === 2 ? stamped ? { color: 'var(--primaryColor)' } : { color: 'gray' } : ''} />
                        <span className="stamps">
                            {stamps}
                        </span>
                        <BsEye style={user.userType === 2 ? viewed ? { color: 'var(--primaryColor)' } : { color: 'gray' } : ''} />
                        <span className="views">
                            {views}
                        </span>
                        {user.userType !== 1 && (
                            <>
                                {conflict > 0 &&
                                    <>
                                        <TbCompass
                                            className={ conflict > 0 ? 'conflictIcon' : 'noIcon'}
                                        />
                                        <span className="conflictCount">{conflict > 0 ? conflict : ''}</span>
                                    </>
                                }
                                {align > 0 &&
                                    <>
                                        <TbCompass
                                            className={ align > 0 ? 'alignIcon' : 'noIcon'}
                                        />
                                        <span className="alignCount">{align > 0 ? align : ''}</span>
                                    </>
                                }
                            </>
                        )}
                         {/* Here I'll put the followed group stamp tally for general users */}
                    </div>
                </div>
                <hr />

                {user.userType === 0
                    ? followedGroupsBar()
                    : authorThemeBar()
                }


            </div>
            {isModalOpen &&
                <DraftModal
                    setMainContent={setMainContent}
                    onClose={toggleModal}
                    datum_i={data}
                    openFlag={isModalOpen}
                    ceFlag='2'
                    btn_flag='draft'
                    datum_state={datum_state}
                />}

        </>
    )
}

export default DatumList